import React, { useRef, useState } from "react";
import QRCode from "react-qr-code";
import "./restaurantQrGenerator.css";

const RestaurantQRGenerator = () => {
  const [placeId, setPlaceId] = useState("");
  const size = 256;
  const svgRef = useRef(null);

  const buildReviewLink = (id) => {
    if (!id) return "";
    return `https://search.google.com/local/writereview?placeid=${id}`;
  };

  const extractPlaceId = (input) => {
    const trimmed = input.trim();
    try {
      if (trimmed.startsWith("http")) {
        const u = new URL(trimmed);
        const pid = u.searchParams.get("placeid");
        if (pid) return pid;
        const m = trimmed.match(/place\/(?:.+)\/data.*!1s([a-zA-Z0-9:_-]+)/);
        if (m && m[1]) return m[1];
      }
    } catch (e) {}
    return trimmed;
  };

  const reviewLink = buildReviewLink(placeId);

  const downloadPNG = async () => {
    try {
      const svg = svgRef.current.querySelector("svg");
      if (!svg) throw new Error("SVG bulunamadı");

      const serializer = new XMLSerializer();
      let svgStr = serializer.serializeToString(svg);

      if (!svgStr.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
        svgStr = svgStr.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
      }

      svgStr = '<?xml version="1.0" standalone="no"?>\n' + svgStr;

      const svgBlob = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(svgBlob);

      const img = new Image();
      img.onload = () => {
        const padding = 20;
        const canvas = document.createElement("canvas");
        canvas.width = size + (padding * 2);
        canvas.height = size + (padding * 2);
        const ctx = canvas.getContext("2d");
        
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, padding, padding, size, size);
        URL.revokeObjectURL(url);
        const pngUrl = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = pngUrl;
        a.download = "restaurant-qr.png";
        document.body.appendChild(a);
        a.click();
        a.remove();
      };
      img.onerror = () => alert("QR görüntüsü oluşturulamadı");
      img.crossOrigin = "anonymous";
      img.src = url;
    } catch (err) {
      alert("İndirme sırasında hata: " + err.message);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(reviewLink);
      alert("Yorum linki panoya kopyalandı.");
    } catch (e) {
      prompt("Kopyalayamadım. Manuel olarak kopyalayın:", reviewLink);
    }
  };

  return (
    <div className="rqr-container">
      <h1 className="rqr-title">
        Google Yorum QR Kod Üretici
      </h1>

      <div className="rqr-grid">
        <div className="rqr-form-section">
          <div className="rqr-input-group">
            <h3 className="rqr-input-title">Google Place ID</h3>
            <p className="rqr-input-desc">
              Place ID veya Google Maps URL'sini yapıştırın
            </p>
            <p className="rqr-input-link">
              <a 
                href="https://developers.google.com/maps/documentation/javascript/examples/places-placeid-finder" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Place ID bulamıyor musunuz? Buradan bulabilirsiniz →
              </a>
            </p>
            <div className="rqr-input-container">
              <input
                className="rqr-input"
                placeholder="Place ID veya Maps URL"
                value={placeId}
                onChange={(e) => setPlaceId(extractPlaceId(e.target.value))}
              />
              {placeId && (
                <button
                  className="rqr-clear-btn"
                  onClick={() => setPlaceId("")}
                  title="Temizle"
                >
                  ×
                </button>
              )}
            </div>
          </div>

          <div className="rqr-buttons">
            <button
              className="rqr-btn rqr-btn-blue"
              onClick={copyLink}
              disabled={!reviewLink}
            >
              Linki Kopyala
            </button>

            <button
              className="rqr-btn rqr-btn-indigo"
              onClick={downloadPNG}
              disabled={!reviewLink}
            >
              PNG Olarak İndir
            </button>

            <a
              className="rqr-link"
              href={reviewLink}
              target="_blank"
              rel="noreferrer"
            >
              Yorum sayfasını yeni sekmede aç
            </a>
          </div>
        </div>

        <div className="rqr-qr-section">
          <div className="rqr-qr-container" ref={svgRef}>
            {reviewLink ? (
              <QRCode 
                value={reviewLink} 
                size={size} 
                bgColor="#ffffff"
                fgColor="#000000"
                level="M"
              />
            ) : (
              <div className="rqr-placeholder">
                <div className="rqr-placeholder-icon">📱</div>
                <p>Place ID girin</p>
              </div>
            )}
          </div>

          <div className="rqr-description">
            QR'yi okutunca kullanıcı doğrudan Google yorum yazma ekranına
            yönlendirilir.
          </div>
        </div>
      </div>
    </div>
  );
};
export default RestaurantQRGenerator;